import SpeciesDisplaySimple from "./SpeciesDisplaySimple";

export default SpeciesDisplaySimple;
export { SpeciesDisplaySimple };
